import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipmentCategories } from "@/features/equipments/hooks/useEquipmentCategories";
import { EquipmentCategoryData } from "@/features/equipments/types/equipments.type";
import DashboardFilterSheet from "../DashboardFilterSheet";

const DashboardFilterEquipmentCategorySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: equipmentCategoriesOptions,
  } = useEquipmentCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<EquipmentCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.EquipmentCategory}
      options={equipmentCategoriesOptions}
      filters={filters}
      setFilters={setFilters}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEquipmentCategorySheet;
